import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { AllocationViewActionBaseState } from '../base';
import {
  AllocationViewCallToWaitingAreaAction,
  AllocationViewCallToWaitingAreaActionSetCloseAfterCompleteState,
  AllocationViewCallToWaitingAreaActionSetInitialState,
} from './allocation-view-call-to-waiting-area-action.actions';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { AllocationViewCallToWaitingAreaActionService } from './allocation-view-call-to-waiting-area-action.service';
import { NotificationService } from '../../../../../../common';
import { AllocationDetailsModel } from '../../models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewCallToWaitingAreaActionStateModel {
  loaded: boolean;
  allocationDetails: AllocationDetailsModel;
  closeContainerAfterComplete: boolean;
  callToWaitingAreaFinished: boolean;
}

const initialState: AllocationViewCallToWaitingAreaActionStateModel = {
  loaded: false,
  allocationDetails: null,
  closeContainerAfterComplete: true,
  callToWaitingAreaFinished: false,
};

//TODO: finalize when BE is done
@State({
  name: 'allocationViewActionsCallToWaitingArea',
  defaults: initialState,
})
@Injectable()
export class AllocationViewCallToWaitingAreaActionState extends AllocationViewActionBaseState {
  @Selector()
  static getLoaded(state: AllocationViewCallToWaitingAreaActionStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getCallToWaitingAreaFinished(state: AllocationViewCallToWaitingAreaActionStateModel): boolean {
    return state.callToWaitingAreaFinished;
  }

  constructor(
    private allocationViewCallToWaitingAreaActionService: AllocationViewCallToWaitingAreaActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewCallToWaitingAreaActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewCallToWaitingAreaActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }

  @Action(AllocationViewCallToWaitingAreaAction)
  callToWaitingArea(
    ctx: StateContext<AllocationViewCallToWaitingAreaActionStateModel>,
    { payload: { identifier } }: AllocationViewCallToWaitingAreaAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewCallToWaitingAreaActionService
      .callToWaitingArea({
        ...identifier,
      })
      .pipe(
        tap(() => {
          ctx.patchState({ callToWaitingAreaFinished: true });
          const { closeContainerAfterComplete } = ctx.getState();
          this.finishAction('api.uli.success.calledToWaitingArea', closeContainerAfterComplete);
        }),
        catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
      );
  }

  @Action(AllocationViewCallToWaitingAreaActionSetCloseAfterCompleteState)
  setCloseContainerAfterCompleteState(
    ctx: StateContext<AllocationViewCallToWaitingAreaActionStateModel>,
    { payload }: AllocationViewCallToWaitingAreaActionSetCloseAfterCompleteState,
  ): void {
    ctx.patchState({ closeContainerAfterComplete: payload });
  }
}
